import { Svg, SvgImage, SvgProps, SvgRect, registerSVG } from '../../../components/svg';

export function WalmartBadge(props: SvgProps) {
  return (
    <Svg {...props} viewBox="0 0 64 24" width="64px" height="24px" fill="none">
      <SvgRect width="64" height="24" rx="4" fill="#0071DC" />
      <SvgImage width="48" height="16" x="8" y="4" href={require('./WalmartLogoWhite.png')} />
    </Svg>
  );
}

registerSVG('WalmartBadge', WalmartBadge);
